import React, {useEffect, useRef, useState} from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Container} from "react-bootstrap";

import StatusColumn from "./StatusColumn";
import ModalFahrzeug from "./ModalFahrzeug";
import useAuthorization from "../auth/useAuthorization";
import {STATUS} from "../utils/status";

export const Overview = (props) => {
  const {canWrite, zitadelRollen} = useAuthorization();
  const hasFahrauftragSettingsRole = zitadelRollen.includes(
    "fahrzeugverwaltung.settings.fahrauftrag",
  );
  const [fahrzeuge, setFahrzeuge] = useState([]);
  const [fahrzeugeSort, setFahrzeugeSort] = useState([]);
  const [funkkennungen, setFunkkennungen] = useState([]);
  const [activeID, setActiveID] = useState("");
  const [activeFahrzeug, setActiveFahrzeug] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalFunkkennung, setModalFunkkennung] = useState("");
  const [modalStandort, setModalStandort] = useState("");
  const [modalBemerkung, setModalBemerkung] = useState("");
  const [dragItem, setDragItem] = useState({
    dragging: true,
    id: "",
    column: "",
    target: "",
    targetStore: "",
  });
  const [desDate, setDesDate] = useState(new Date());
  const [recentFahrauftragIds, setRecentFahrauftragIds] = useState([]);
  const previousStatusByIdRef = useRef({});
  const isInitializedStatusRef = useRef(false);
  const clearHighlightTimeoutsRef = useRef({});


  // const fahrzeugeRef = collection(db, "fahrzeuge");
  // const funkkennungenRef = collection(db, "funkkennungen");

  useEffect(() => {
    props.setSearchString("");
  }, []);

  useEffect(() => {
    // const queryFahrzeuge = query(fahrzeugeRef, orderBy("funkkennung"));

    // const unsubscribe = onSnapshot(queryFahrzeuge, (snapshot) => {
    //   let fahrzeuge = [];
    //   snapshot.forEach((doc) => {
    //     fahrzeuge.push({ ...doc.data(), id: doc.id });
    //   });
    //   setFahrzeuge(fahrzeuge);
    // });

    // const queryFunkkennungen = query(funkkennungenRef, orderBy("bezeichnung"));

    // const unsubscribe2 = onSnapshot(queryFunkkennungen, (snapshot) => {
    //   let funkkennungen = [];
    //   snapshot.forEach((doc) => {
    //     funkkennungen.push({ ...doc.data(), id: doc.id });
    //   });
    //   setFunkkennungen(funkkennungen);
    // });

    setFahrzeuge(props.fahrzeuge);
    setFunkkennungen(props.funkkennungen);
  }, [props.fahrzeuge, props.funkkennungen]);

  useEffect(() => {
    if (!hasFahrauftragSettingsRole) {
      return;
    }

    const nextStatusById = {};
    const newFahrauftragIds = [];
    const removedFahrauftragIds = [];

    props.fahrzeuge.forEach((fahrzeug) => {
      nextStatusById[fahrzeug.id] = fahrzeug.status;
      const previousStatus = previousStatusByIdRef.current[fahrzeug.id];

      if (
        isInitializedStatusRef.current &&
        previousStatus &&
        previousStatus !== "fahrauftrag" &&
        fahrzeug.status === "fahrauftrag"
      ) {
        newFahrauftragIds.push(fahrzeug.id);
      }

      if (
        isInitializedStatusRef.current &&
        previousStatus === "fahrauftrag" &&
        fahrzeug.status !== "fahrauftrag"
      ) {
        removedFahrauftragIds.push(fahrzeug.id);
      }
    });

    previousStatusByIdRef.current = nextStatusById;

    if (!isInitializedStatusRef.current) {
      isInitializedStatusRef.current = true;
      return;
    }

    if (newFahrauftragIds.length === 0) {
      if (removedFahrauftragIds.length > 0) {
        setRecentFahrauftragIds((prev) =>
          prev.filter((id) => !removedFahrauftragIds.includes(id)),
        );

        removedFahrauftragIds.forEach((id) => {
          if (clearHighlightTimeoutsRef.current[id]) {
            clearTimeout(clearHighlightTimeoutsRef.current[id]);
            delete clearHighlightTimeoutsRef.current[id];
          }
        });
      }

      return;
    }

    if (removedFahrauftragIds.length > 0) {
      setRecentFahrauftragIds((prev) =>
        prev.filter((id) => !removedFahrauftragIds.includes(id)),
      );

      removedFahrauftragIds.forEach((id) => {
        if (clearHighlightTimeoutsRef.current[id]) {
          clearTimeout(clearHighlightTimeoutsRef.current[id]);
          delete clearHighlightTimeoutsRef.current[id];
        }
      });
    }

    setRecentFahrauftragIds((prev) => {
      const merged = [...prev];
      newFahrauftragIds.forEach((id) => {
        if (!merged.includes(id)) {
          merged.push(id);
        }
      });
      return merged;
    });

    newFahrauftragIds.forEach((id) => {
      if (clearHighlightTimeoutsRef.current[id]) {
        clearTimeout(clearHighlightTimeoutsRef.current[id]);
      }

      clearHighlightTimeoutsRef.current[id] = setTimeout(() => {
        setRecentFahrauftragIds((prev) => prev.filter((entry) => entry !== id));
        delete clearHighlightTimeoutsRef.current[id];
      }, 60000);
    });

    try {
      const notificationSound = new Audio("/sounds/sound_not_fahrauftrag.mp3");
      notificationSound.play().catch(() => {
        // Ignore browser autoplay policy errors.
      });
    } catch (error) {
      // Ignore browser/audio errors.
    }
  }, [props.fahrzeuge, hasFahrauftragSettingsRole]);

  useEffect(() => {
    const timeoutMap = clearHighlightTimeoutsRef.current;

    return () => {
      Object.values(timeoutMap).forEach((timeoutId) => {
        clearTimeout(timeoutId);
      });
    };
  }, []);

  useEffect(() => {
    const filterFahrzeuge = (fahrzeug) => {
      return (
        fahrzeug.funkkennung
          .toLowerCase()
          .includes(props.searchString.toLowerCase()) ||
        fahrzeug.kennzeichen
          .toLowerCase()
          .includes(props.searchString.toLowerCase()) ||
        fahrzeug.standort
          .toLowerCase()
          .includes(props.searchString.toLowerCase()) ||
        fahrzeug.bemerkung
          .toLowerCase()
          .includes(props.searchString.toLowerCase())
      );
    };

    let fahrzeugeSort = [];

    fahrzeuge.forEach((element) => {
      fahrzeugeSort.push(element);
      if (element.id === activeID) {
        setModalFunkkennung(element.funkkennung);
      }
    });

    fahrzeugeSort.sort((a, b) => {
      return a.kennzeichen.localeCompare(b.kennzeichen);
    });

    fahrzeugeSort.sort((a, b) => {
      if (a.funkkennung === "") return 1;
      if (b.funkkennung === "") return -1;
      return a.funkkennung.localeCompare(b.funkkennung);
    });

    // Filtern der Fahrzeuge mit searchString
    if (props.searchString !== "") {
      fahrzeugeSort = fahrzeugeSort.filter(filterFahrzeuge);
    }

    setFahrzeugeSort(fahrzeugeSort);
  }, [fahrzeuge, activeID, props.searchString]);

  const dragStart = (e, id, column) => {
    if (!canWrite) {
      return;
    }

    // console.log("dragStart", dragItem);
    e.target.classList.add("dragging");
    setDragItem({
      dragging: true,
      id,
      column,
      target: "",
      targetStore: "",
    });
  };

  const dragEnter = (e, target) => {
    if (dragItem.target !== target && dragItem.column !== target) {
      const tmpDragItem = {
        dragging: dragItem.dragging,
        id: dragItem.id,
        column: dragItem.column,
        target,
        targetStore: target,
      };
      setDragItem(tmpDragItem);
    }
  };

  const dragEnd = (e, id, column) => {
    if (!canWrite) {
      return;
    }

    // console.log('dragEnd (Overview.js)', dragItem, id);
    e.target.classList.remove("dragging");

    if (dragItem.target === "") return false;

    handleOpenModal(id);

    // Update collection Fahrzeuge
    // Fahrzeug mit der ID bekommt aktuellen Status + Anpassungen
    // console.log('Update Fahrzeug in DB:', dragItem.id, dragItem.target);

    // const docRef = doc(db, "fahrzeuge", dragItem.id);

    // const data = {
    //   status: dragItem.target,
    // };

    // setDoc(docRef, data, { merge: true })
    //   .then((docRef) => {
    //     handleOpenModal(id);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    // setTimeout(() => {
    //   setDragItem({
    //     dragging: true,
    //     id,
    //     column,
    //     target: "",
    //   });
    // }, 50);
  };

  const handleOpenModal = (id) => {
    if (!canWrite) {
      return;
    }

    setActiveID(id);
    setDragItem({
      dragging: false,
      id: dragItem.id,
      column: dragItem.column,
      target: "",
      targetStore: dragItem.targetStore,
    });
    // getDataById(id);

    // Infos für Modal laden
    fahrzeuge.forEach((element) => {
      if (element.id === id) {
        setActiveFahrzeug(element);
        setModalFunkkennung(element.funkkennung);
        setModalStandort(element.standort);
        setModalBemerkung(element.bemerkung);
      }
    });

    setShowModal(true);
    // setTimeout(() => setShowModal(true), 500);
  };

  // const getDataById = async (id) => {
  //   const docRef = doc(db, "fahrzeuge", id);
  //   try {
  //     const docSnap = await getDoc(docRef);
  //     setActiveFahrzeug(docSnap.data());
  //     setModalFunkkennung(docSnap.data().funkkennung);
  //     setModalStandort(docSnap.data().standort);
  //     setModalBemerkung(docSnap.data().bemerkung);
  //     // console.log(docSnap.data());
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const closeModal = () => {
    setShowModal(false);
    setDragItem({
      dragging: true,
      id: "",
      column: "",
      target: "",
      targetStore: "",
    });
  };

  return (
    <>
      <ModalFahrzeug
        id={activeID}
        fahrzeug={activeFahrzeug}
        fahrzeuge={fahrzeuge}
        funkkennung={modalFunkkennung}
        funkkennungen={funkkennungen}
        standort={modalStandort}
        setStandort={setModalStandort}
        bemerkung={modalBemerkung}
        setBemerkung={setModalBemerkung}
        showModal={showModal}
        closeModal={closeModal}
        target={dragItem.targetStore}
        desDate={desDate}
        setDesDate={setDesDate}
        canWrite={canWrite}
      />
      <Container fluid>
        <Row>
          {/* <div>
            dragging: {dragItem.dragging ? "true" : "false"}
            <br />
            id: {dragItem.id}
            <br />
            column: {dragItem.column}
            <br />
            target: {dragItem.target}
            <br />
            targetStore: {dragItem.targetStore}
          </div> */}
          {STATUS.map((column) => {
            return (
              <Col key={column.column}>
                <StatusColumn
                  title={column.title}
                  bg={column.bg}
                  color={column.color}
                  column={column.column}
                  data={fahrzeugeSort}
                  dragItem={dragItem}
                  dragEnter={dragEnter}
                  dragStart={dragStart}
                  dragEnd={dragEnd}
                  handleOpenModal={handleOpenModal}
                  gotoFahrzeugPage={props.gotoFahrzeugPage}
                  canWrite={canWrite}
                  recentFahrauftragIds={recentFahrauftragIds}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </>
  );
};

export default Overview;
